export default "__VITE_ASSET__mIfiqIYS__"